import { Component } from '@angular/core';

@Component({
  selector: 'page-content',
  templateUrl: './page-content.component.html',
})
export class PageContentComponent {}
